import {getLogger} from './logging'

declare global {
  interface Window {
    clarity?: (...args: any[]) => void
  }
}

export enum ClarityEvent {
  AddToCart = 'AddToCartNewIBE',
  RemoveFromCart = 'RemoveFromCartNewIBE',
  ContinueShopping = 'ContinueShoppingNewIBE',
  Checkout = 'CheckoutNewIBE',
  CompleteGuestInfo = 'CompleteGuestInfoNewIBE',
  CompletePayment = 'CompletePaymentNewIBE',
  CompleteBooking = 'CompleteBookingNewIBE',
  BookingFailed = 'BookingFailedNewIBE',
  PaymentFailed = 'PaymentFailedNewIBE',
  NoSearchResults = 'NoSearchResultsNewIBE'
}

const logger = getLogger('clarity')

/**
 * Sends a clarity event to the Microsoft Clarity analytics service.
 * @param event The clarity event to send.
 */
export function sendClarityEvent(event: ClarityEvent): void {
  try {
    if (window.clarity) {
      logger.debug({
        message: 'Sending clarity event',
        data: {event}
      })
      window.clarity('event', event)
    }
  } catch (e) {
    logger.error({
      message: 'Failed to send clarity event',
      errorData: {
        error: e.message,
        stack: e.stack
      }
    })
  }
}

/**
 * Sets the IBE session ID in Microsoft Clarity.
 * @param sessionId
 */
export function setIbeSessionId(sessionId: string): void {
  try {
    if (window.clarity) {
      logger.debug({
        message: 'Setting clarity session ID',
        data: {sessionId}
      })
      window.clarity('set', 'ibe_session_id', sessionId)
    }
  } catch (e) {
    logger.error({
      message: 'Failed to set clarity session ID',
      errorData: {
        error: e.message,
        stack: e.stack
      }
    })
  }
}
